import React, { useRef } from 'react';
import { Spinner } from 'react-bootstrap';

import { APIUtiltity } from '../../../API';
import { ReactComponent as Logo } from '../../../img/svg/Logos/SLetterBlue.svg';
import { ReactComponent as Check } from '../../../img/svg/CheckMark/minicheck.svg';

export default function SlideDrawer({
  walletId = '',
  show = false,
  loading = true,
  notifications = [],
  page = 1,
  getNotifications = () => {}
}) {
  const observer = useRef(null);

  const markAllAsReadHandler = async () => {
    const res = await APIUtiltity.markAsReadAllNotifications();
    if (res.status === 200) getNotifications();
    else console.log(res);
  };

  const lastItemRef = React.useCallback(
    (node) => {
      if (loading || !notifications.length) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && page) getNotifications(page);
      });
      if (node) observer.current.observe(node);
    },
    [loading, page]
  );

  return (
    <div className={`side-drawer ${show ? 'open' : ''}`}>
      <div className="notifications-heading">
        <h4 className="mb-0 font-family-gemsbuck">Notifications</h4>
        <span onClick={() => markAllAsReadHandler()}>
          <Check />
          Mark all as read
        </span>
      </div>
      <div className="notifications-list-container">
        {notifications.length
          ? notifications.map((n, index) => (
              <div
                className={`notification-tab ${index % 2 !== 0 ? 'odd' : ''}`}
                key={index}
                ref={notifications.length === index + 1 ? null : lastItemRef}
              >
                <div className="left">
                  <Logo />
                </div>
                <div className={`right ${n.markAsRead ? 'low-opacity' : ''}`}>
                  <div className="title">{n.title}</div>
                  <div className="description">{n.description}</div>
                </div>
              </div>
            ))
          : !loading && (
              <div className="no-notifications-text">No Notifications</div>
            )}
        {loading && (
          <div style={{ margin: '1.5rem', textAlign: 'center' }}>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        )}
      </div>
    </div>
  );
}
